export default "__VITE_ASSET__CbeVuDiB__"